import Backbone from 'backbone'
import $ from 'jquery'

/*
 * This is a simple view that follows the user's mouse as they
 * are dragging, helping them along the way
 */
var Guidance = Backbone.View.extend({
  className: 'image-upload-message',

  initialize: function (uploadMessage) {
    this.uploadMessage = uploadMessage
  },

  render: function () {
    var template = '<div class="dotted-line">' +
                   '  <div class="floating-content">' +
                   '    <i class="upload-large-icon"></i>' +
                   '    <div>' + this.uploadMessage + '</div>' +
                   '  </div>' +
                   '</div>'
    this.$el.html(template)
    return this
  }

})

/*
 * Adds functionality so an image can be dropped onto the canvas
 *  Only turned on if this wobs support an 'image' widgetType
 */
var Droppable = Backbone.View.extend({

  events: {
    'dragenter': 'listen',
    'dragleave ': 'exit',
    'dragover': 'drag', // .image-upload-message
    'drop': 'drop' //.image-upload-message
  },

  initialize: function (options) {
    this.canvas = options.canvas
    this.uploadMessage = options.uploadMessage || 'Drop anywhere to start upload!'

    if (!this.canvas.collection.widgetTypes.image) {
      // Don't turn on events
      this.delegateEvents = function () {}
    }
  },

  listen: function (e) {
    if (e.target == this.el) {
      e.stopPropagation()
      e.preventDefault()

      if (this.guidance) { return } // Early exit because dragenter seems to fire many times

      this.guidance = new Guidance(this.uploadMessage).render()
      this.canvas.$el.append(this.guidance.el)
      this.canvas.trigger('start:droppable')
    }
  },

  /*
   * Returns the mouse position relative to the document
   * @Deprecated
   */
  getMouseCoords: function (e) {
    var x = 0
      , y = 0

    if (!e) var e = window.event

    if (e.pageX || e.pageY) {
      x = e.pageX
      y = e.pageY
    } else if (e.clientX || e.clientY) {
      x = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft
      y = e.clientY + document.body.scrollTop + document.documentElement.scrollTop
    }
    return { x: x, y: y }
  },

  exit: function (e) {
    e.stopPropagation()
    e.preventDefault()

    var canvasCoords = this.canvas.el.getBoundingClientRect()
      , mouseCoords = {
        x: e.originalEvent.clientX,
        y: e.originalEvent.clientY
      }

    // If the event fired and the mouse is outside of the canvas, they are truly done.
    if (mouseCoords.x > canvasCoords.left + canvasCoords.width - 1 || mouseCoords.x < canvasCoords.left
        || mouseCoords.y > canvasCoords.top + canvasCoords.height - 1 || mouseCoords.y < canvasCoords.top) {
      this.reset()
    }
  },

  drag: function (e) {
    e.stopPropagation()
    e.preventDefault()
  },

  /*
   * Destroys guidance
   */
  reset: function () {
    if (this.guidance) {
      this.guidance.remove()
      this.canvas.trigger('end:droppable')
    }
    this.guidance = null
  },

  drop: function (e) {
    this.reset()
    e.stopPropagation()
    e.preventDefault()

    var files = e.originalEvent.dataTransfer.files

    if (files.length === 0) {
      return
    }

    if (e.originalEvent.dataTransfer.files.length > 1) {
      alert('You can only drag one file at a time.')
      return
    }

    var canvasCoords = this.canvas.$el.offset()

    // TODO This is bullshit. This shouldn't be creating the image widgetType, hoping it's magically there.
    this.canvas.create({
      dropped: true,
      left: Math.max(e.originalEvent.offsetX - canvasCoords.left, 0),
      top: Math.max(e.originalEvent.offsetY - canvasCoords.top, 0),
      widget: new this.canvas.collection.widgetTypes.image({}, this.canvas.collection.options)
    }, files)
  },

  release: function () {
    this.undelegateEvents()
  }

})

export default function (options, canvas) {
  if (!canvas) {
    canvas = options
    options = {}
  }
  return new Droppable({canvas: canvas, el: canvas.el, uploadMessage: options.uploadMessage})
}
